module.exports = __webpack_public_path__ + "media/warranty-claim/photos-vent4-74997634.png";